document.addEventListener("DOMContentLoaded", function () {
  const button = document.querySelector("[data-content-reveal-trigger]");
  const content = document.querySelector("[data-content-reveal]");
  const innerContent = content.querySelector(
    ".backed-by-science__content-inner"
  );
  const section = document.querySelector(".backed-by-science");

  button.addEventListener("click", function () {
    const scrollPosition =
      content.getBoundingClientRect().top + window.scrollY - 250;

    if (content.offsetHeight === 0) {
      content.style.height = innerContent.offsetHeight + "px";
      //   toggle expanded class on section
      section.classList.add("expanded");
      // wait 0.3s then scroll to the content offset by 90px only if viewing on mobile screens
      if (window.innerWidth < 768) {
        setTimeout(() => {
          window.scrollTo({ top: scrollPosition, behavior: "smooth" });
        }, 300);
      }
    } else {
      content.style.height = "0px";
      //   toggle expanded class on section
      section.classList.remove("expanded");
    }
  });

  // on window resize
  window.addEventListener("resize", function () {
    if (section.classList.contains("expanded")) {
      content.style.height = innerContent.offsetHeight + "px";
    }
  });
});
